import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createRoom } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export function HomePage() {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [joinCode, setJoinCode] = useState("");
  const navigate = useNavigate();

  async function handleCreate() {
    setLoading(true);
    setError(null);
    try {
      const { code } = await createRoom({ name: name.trim() || undefined });
      navigate(`/room/${code}`);
    } catch {
      setError("Failed to create room. Is the server running?");
    } finally {
      setLoading(false);
    }
  }

  function handleJoin() {
    const code = joinCode.trim().toUpperCase();
    if (code) navigate(`/room/${code}`);
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-8">
        <div className="space-y-6">
          <div className="space-y-1">
            <h1 className="text-2xl font-semibold tracking-tight">Rate Your Group</h1>
            <p className="text-sm text-muted-foreground">
              Create a room, share the link, let everyone vote anonymously.
            </p>
          </div>

          <div className="space-y-3">
            <Input
              placeholder="Room name (optional)"
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => e.key === "Enter" && !loading && handleCreate()}
              disabled={loading}
            />
            <Button className="w-full" onClick={handleCreate} disabled={loading}>
              {loading ? "Creating..." : "Create Room →"}
            </Button>
          </div>

          {error && <p className="text-sm text-destructive">{error}</p>}
        </div>

        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-background px-2 text-muted-foreground">or join existing</span>
          </div>
        </div>

        <div className="space-y-3">
          <Input
            placeholder="Room code"
            value={joinCode}
            onChange={e => setJoinCode(e.target.value.toUpperCase())}
            onKeyDown={e => e.key === "Enter" && handleJoin()}
            className="font-mono tracking-widest uppercase"
          />
          <Button
            variant="outline"
            className="w-full"
            onClick={handleJoin}
            disabled={!joinCode.trim()}
          >
            Join Room →
          </Button>
        </div>
      </div>
    </div>
  );
}
